/* eslint-disable react/jsx-no-undef */
import React, { useState, useCallback, useRef } from 'react';
import { Layout, Menu, Drawer } from 'antd';
import { SeatBookingData } from '../../Redux/action/seatBookingAction';
import { SeatData } from '../../Redux/action/seatAction';
import { RoomMaList } from '../../Redux/action/roomTraingAction';
import { RoomBookingData } from '../../Redux/action/roomAction';
import { toast } from 'react-toastify';

import { useDispatch } from 'react-redux';
import { UserOutlined, DashboardOutlined } from '@ant-design/icons';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  useNavigate,
} from 'react-router-dom';
import axios from 'axios';

import MenuItem from 'antd/es/menu/MenuItem';
import { dataUser, dataLocation } from '../Helpers/util';

import { ReactComponent as DashboardMenuIcon } from './menu-icon/dashboard-icon.svg';
import { ReactComponent as MemberAccessMenuIcon } from './menu-icon/memberAccess-icon.svg';
import { ReactComponent as MealPlanMenuIcon } from './menu-icon/mealPlan-icon.svg';
import { ReactComponent as WalletPointMenuIcon } from './menu-icon/walletPoint-icon.svg';
import { ReactComponent as ReportMenuIcon } from './menu-icon/report-icon.svg';
import { ReactComponent as DocumentsMenuIcon } from './menu-icon/documents-icon.svg';
import { ReactComponent as ParkingMenuIcon } from './menu-icon/parking-icon.svg';
import { ReactComponent as AddonMenuIcon } from './menu-icon/addOn-icon.svg';
import { ReactComponent as SnagListMenuIcon } from './menu-icon/snagList-icon.svg';
import { ReactComponent as SupportMenuIcon } from './menu-icon/support-icon.svg';
import { ReactComponent as SurveyMenuIcon } from './menu-icon/survey-icon.svg';
import { ReactComponent as DeskBookingMenuIcon } from './menu-icon/deskBooking-icon.svg';
import { ReactComponent as MeetingRoomMenuIcon } from './menu-icon/meetingRoom-icon.svg';
import { ReactComponent as AccessControlIcon } from './menu-icon/access-control-icon.svg';
import { ReactComponent as AccountsIcon } from './menu-icon/accounts-icon.svg';
import { Parking } from '../Helpers/api';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';

import VisitorServiceRequest from '../CommonComponent/VisitorServiceRequest';
import AttendanceServiceRequest from '../CommonComponent/AttendanceServiceRequest';
import AccessLogServiceRequest from '../CommonComponent/AccessLogServiceRequest';
import SkyWatchServiceRequest from '../CommonComponent/SkyWatchServiceRequest';
import MeetingRoomServiceRequest from '../CommonComponent/MeetingRoomServiceRequest';
import DeskBookingServiceRequest from '../CommonComponent/DeskBookingServiceRequest';

const { Sider } = Layout;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

const Sidebar = ({ collapsed, showDrawer }) => {
  const [pgno, setPgno] = useState(1);
  const [row, setRow] = useState('25');
  const [SortData, setSortData] = useState('');
  const [company_id, setCompany_id] = React.useState(
    UserObj ? UserObj.company_id : null,
  );
  const [filterData, setFilterData] = React.useState({});
  const [surveyData, setSurveyData] = useState([]);
  const [showAccess, setShowAccess] = useState(false);

  const [showAttendance, setShowAttendance] = useState(false);
  const [showVisitor, setShowVisitor] = useState(false);
  const accessRef = useRef(null);
  const attendanceRef = useRef(null);
  const visitorRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();



  const [showSkyWatch, setShowSkyWatch] = useState(false);
  const skyWatchRef = useRef(null);


  const [showMeetingRoom, setShowMeetingRoom] = useState(false);
  const MeetingRoomRef = useRef(null);


  const [showDeskBooking, setShowDeskBooking] = useState(false);
  const DeskBookingRef = useRef(null);

  const siderStyle = {
    overflow: 'auto',
    height: 'calc(100vh - 50px)',
    position: 'fixed',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
    marginTop: '50px',
    background: '#fff',
  };

  const [userRole] = useState([
    {
      service_id: '1',
      role_for_read: '1',
      role_for_write: '0',
    },
    {
      service_id: '28',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '3',
      role_for_read: '0',
      role_for_write: '1',
    },
    {
      service_id: '31',
      role_for_read: '0',
      role_for_write: '1',
    },
    {
      service_id: '16',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '5',
      role_for_read: '0',
      role_for_write: '1',
    },
    {
      service_id: '8',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '4',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '15',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '2',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '12',
      role_for_read: '0',
      role_for_write: '1',
    },

    {
      service_id: '14',
      role_for_read: '0',
      role_for_write: '1',
    },
    {
      service_id: '18',
      role_for_read: '0',
      role_for_write: '1',
    },
    {
      service_id: '17',
      role_for_read: '0',
      role_for_write: '1',
    },
  ]);

  const ManageMembers = userRole.find(element => element.service_id == '1');
  const mealPlan = userRole.find(element => element.service_id == '28');
  const VisitorLogs = userRole.find(element => element.service_id == '3');
  const accessLogs = userRole.find(element => element.service_id == '31');
  const RoomBookingAnalytics = userRole.find(
    element => element.service_id == '16',
  );
  const Compliance = userRole.find(element => element.service_id == '5');
  const ParkingRequest = userRole.find(element => element.service_id == '8');
  const RoomManagement = userRole.find(element => element.service_id == '4');
  const SeatBookingAnalytics = userRole.find(
    element => element.service_id == '15',
  );
  const SeatManagement = userRole.find(element => element.service_id == '2');
  const SeatPlanning = userRole.find(element => element.service_id == '12');
  const DepartmentMaster = userRole.find(element => element.service_id == '14');
  const FlexiSeatAnalytics = userRole.find(
    element => element.service_id == '18',
  );
  const SupportTickets = userRole.find(element => element.service_id == '17');

  const handleAddonClick = type => {
    navigate(`/Dashboard?drawerType=${type}`);
  };

  //  these functions are applied in lists to get data from redux

  // const getUsers = useCallback(() => {
  //   setRow(prev => prev || '25'); // Ensure row is never 0

  //   const params = {
  //     pgno,
  //     order: SortData,
  //     company_id: UserObj?.company_id,
  //     row: row || '25', // Default value if row is 0 or empty
  //     location: JSON.stringify(LocationObj),
  //   };

  //   dispatch(SeatBookingData(params));
  // }, [pgno, SortData, row, UserObj, LocationObj]);

  //     order: this.state.SortData,
  //     company_id: this.state.company_id,
  //     row: this.state.row,

  function getSeatManagementData() {
    const params = {
      pgno: pgno,
      row: row,
      company_id: company_id,
    };
    dispatch(SeatData(params));
  }

  const handleClose = (isSuccess = false, successMessage = '') => {
    // 1️⃣ close OffCanvas
    setShowAccess(false);
    setShowAttendance(false)
    setShowVisitor(false)

    // 2️⃣ show toast AFTER OffCanvas animation
    if (isSuccess && successMessage) {
      setTimeout(() => {
        toast.success(successMessage, {
          autoClose: 3000,
        });
      }, 300); // ✅ small delay
    }
  };

  // function getRoomManagementData() {
  //   let params = {
  //     pgno: pgno,
  //     company_id: company_id,
  //     row: row,
  //   };
  //   dispatch(RoomMaList(params));
  // }

  const getRoomList = () => {
    var setFelterdata = JSON.stringify(filterData);
    const formData = new FormData();
    formData.append('pgno', pgno);
    formData.append('sort', SortData);
    formData.append('company_id', company_id);
    formData.append('formdata', setFelterdata);
    formData.append('row', row);

    const param = {
      pgno: pgno,
      sort: SortData,
      company_id: company_id,
      formdata: setFelterdata,
      row: row,
    };

    dispatch(RoomBookingData(param));
  };

  // to render survey on condition
  React.useEffect(() => {
    const getSurvey = async () => {
      const userid = UserObj?.rec_id;
      const authToken = JSON.parse(localStorage.getItem('headData'));

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL
          }survey/getSurveyByCompany/${company_id}/${userid}`,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );

        if (response.data.statusValue === 200) {
          setSurveyData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching survey data:', error);
      }
    };

    getSurvey();
  }, [company_id]);

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        style={siderStyle}
        collapsedWidth={60}
        width={240}
      >
        <Menu theme="light" mode="inline" defaultSelectedKeys={['1']}>
          <Menu.Item icon={<DashboardMenuIcon />}>
            <Link to="/Dashboard">Dashboard</Link>
          </Menu.Item>

          {ManageMembers &&
            (ManageMembers.role_for_read === '1' ||
              ManageMembers.role_for_write === '1') ? (
            <Menu.Item icon={<MemberAccessMenuIcon />}>
              <Link to="/ActiveMember">Member Access</Link>
            </Menu.Item>
          ) : (
            ''
          )}

          {mealPlan &&
            (mealPlan.role_for_read == '1' || mealPlan.role_for_write == '1') ? (
            <Menu.SubMenu icon={<MealPlanMenuIcon />} title="Meal Plans">
              <Menu.Item>
                <Link to="/meal-plan-users">Meal Plan Users</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to="/meal-plan-report">Meal Plan Report</Link>
              </Menu.Item>
            </Menu.SubMenu>
          ) : (
            ''
          )}

          <Menu.SubMenu icon={<WalletPointMenuIcon />} title="Wallet Points">
            <Menu.Item>
              <Link to="/explore-wallet-point">Explore Wallet Points</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/wallet-dashboard">Wallet Dashboard</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/point-distribution">Distribute</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/redemption-report">Redemption Report</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/distribution-report">Distribution Report</Link>
            </Menu.Item>
          </Menu.SubMenu>

          <Menu.SubMenu icon={<ReportMenuIcon />} title="Reports">
            {VisitorLogs &&
              (VisitorLogs.role_for_read == '1' ||
                VisitorLogs.role_for_write == '1') ? (
              <Menu.Item>
                <Link to="/VisitorManagement">Visitor</Link>
              </Menu.Item>
            ) : (
              ''
            )}
            {accessLogs &&
              (accessLogs.role_for_read == '1' ||
                accessLogs.role_for_write == '1') &&
              UserObj?.service_add_on?.access_management !== 1 ? (
              <Menu.Item>
                <Link to="/access-logs">Access Logs</Link>
              </Menu.Item>
            ) : (
              ''
            )}

            {(UserObj?.company_id == 202 || UserObj?.company_id == 2223) &&
              UserObj?.service_add_on?.access_management !== 1 ? (
              <Menu.Item>
                <Link to="/rfid-logs">RFID Logs </Link>
              </Menu.Item>
            ) : (
              ''
            )}
          </Menu.SubMenu>
          {UserObj?.service_add_on?.access_management === 1 && (
            <Menu.SubMenu icon={<AccessControlIcon />} title="Access Control">
              <Menu.Item>
                <Link to="/user-access-management">User Access Management</Link>
              </Menu.Item>
              {accessLogs &&
                (accessLogs.role_for_read == '1' ||
                  accessLogs.role_for_write == '1') ? (
                <Menu.Item>
                  <Link to="/access-logs">Access Logs</Link>
                </Menu.Item>
              ) : (
                ''
              )}

              {UserObj?.company_id == 202 || UserObj?.company_id == 2223 ? (
                <Menu.Item>
                  <Link to="/rfid-logs">RFID Logs </Link>
                </Menu.Item>
              ) : (
                ''
              )}
            </Menu.SubMenu>
          )}

          {Compliance &&
            (Compliance.role_for_read == '1' ||
              Compliance.role_for_write == '1') ? (
            <Menu.Item icon={<DocumentsMenuIcon />}>
              <Link to="/LegalAndCompliance">Documents</Link>
            </Menu.Item>
          ) : (
            ''
          )}

          <Menu.Item icon={<AccountsIcon />}>
            <Link to="/CustomerPortal">Accounts</Link>
          </Menu.Item>

          {ParkingRequest &&
            (ParkingRequest.role_for_read == '1' ||
              ParkingRequest.role_for_write == '1') ? (
            <Menu.Item icon={<ParkingMenuIcon />}>
              <Link to="/park-plus">Parking</Link>
            </Menu.Item>
          ) : (
            ''
          )}

          <Menu.SubMenu icon={<AddonMenuIcon />} title="Add-On Products">
            <Menu.Item
              key="desk-booking"
              // onClick={() => handleAddonClick('desk-booking')}
              onClick={() => setShowDeskBooking(true)}
            >
              Desk Booking
            </Menu.Item>
            <Menu.Item
              key="meeting-room"
              // onClick={() => handleAddonClick('meeting-room')}
              onClick={() => setShowMeetingRoom(true)}
            >
              Meeting Rooms
            </Menu.Item>
            <Menu.Item
              key="skywatch"
              // onClick={() => handleAddonClick('skywatch')} //comment for new code 
              onClick={() => setShowSkyWatch(true)}
            >
              SkyWatch
            </Menu.Item>

            <Menu.Item key="access-control" onClick={() => setShowAccess(true)}>
              Access Control
            </Menu.Item>
            <Menu.Item key="attendance" onClick={() => setShowAttendance(true)}>
              Attendance
            </Menu.Item>
            <Menu.Item
              key="visitor-management"
              onClick={() => setShowVisitor(true)}
            >
              Visitor Management
            </Menu.Item>
            <Menu.Item key="rewardkart">
              <Link to="/corporate-gifting">RewardKart</Link>
            </Menu.Item>
            <Menu.Item key="tata-tele">
              <Link to="/tata-teleservice"> TATA TeleServices</Link>
            </Menu.Item>
          </Menu.SubMenu>

          <Menu.SubMenu icon={<DeskBookingMenuIcon />} title="Desk Booking">
            {SeatBookingAnalytics &&
              (SeatBookingAnalytics.role_for_read == '1' ||
                SeatBookingAnalytics.role_for_write == '1') ? (
              <Menu.Item>
                <Link
                  to="/SeatBooking"
                // onClick={getUsers}
                >
                  Seat Bookings
                </Link>
              </Menu.Item>
            ) : (
              ''
            )}

            {SeatManagement &&
              (SeatManagement.role_for_read == '1' ||
                SeatManagement.role_for_write == '1') ? (
              <MenuItem>
                <Link to="/SeatManagement" onClick={getSeatManagementData}>
                  Manage Seats
                </Link>
              </MenuItem>
            ) : (
              ''
            )}
            {SeatPlanning &&
              (SeatPlanning.role_for_read == '1' ||
                SeatPlanning.role_for_write == '1') ? (
              <MenuItem>
                <Link to="/roster">Seat Planning</Link>
              </MenuItem>
            ) : (
              ''
            )}

            {DepartmentMaster &&
              (DepartmentMaster.role_for_read == '1' ||
                DepartmentMaster.role_for_write == '1') ? (
              <MenuItem>
                <Link to="/department">Department Master</Link>
              </MenuItem>
            ) : (
              ''
            )}
            {FlexiSeatAnalytics &&
              (FlexiSeatAnalytics.role_for_read == '1' ||
                FlexiSeatAnalytics.role_for_write == '1') ? (
              <MenuItem>
                <Link to="/bookinginfoseat">Analytics</Link>
              </MenuItem>
            ) : (
              ''
            )}
          </Menu.SubMenu>

          <Menu.SubMenu icon={<MeetingRoomMenuIcon />} title="Meeting Rooms">
            {RoomManagement &&
              (RoomManagement.role_for_read == '1' ||
                RoomManagement.role_for_write == '1') ? (
              <Menu.Item>
                <Link
                  to="/RoomManagement"
                //  onClick={getRoomManagementData}
                >
                  Room Management
                </Link>
              </Menu.Item>
            ) : (
              ''
            )}

            {RoomBookingAnalytics &&
              (RoomBookingAnalytics.role_for_read == '1' ||
                RoomBookingAnalytics.role_for_write == '1') ? (
              <MenuItem>
                <Link
                  to="/RoomBooking"
                // onClick={getRoomList}
                >
                  Room Booking
                </Link>
              </MenuItem>
            ) : (
              ''
            )}
          </Menu.SubMenu>

          <Menu.Item icon={<SnagListMenuIcon />}>
            <Link to="/SnagListManagement">Snag List</Link>
          </Menu.Item>

          {SupportTickets &&
            (SupportTickets.role_for_read == '1' ||
              SupportTickets.role_for_write == '1') ? (
            <Menu.Item icon={<SupportMenuIcon />}>
              <Link to="/TicktingManagement">Support</Link>
            </Menu.Item>
          ) : (
            ''
          )}
          {surveyData.length > 0 ? (
            <Menu.Item icon={<SurveyMenuIcon />}>
              <Link to="/SurveyManagementPage">Surveys</Link>
            </Menu.Item>
          ) : (
            ''
          )}
        </Menu>
        :
      </Sider>
      <SwOffCanvas
        show={showAccess}
        onClose={handleClose} // ✅ USE THIS
        title="Access Control"
        placement="end"
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton
              variant="dark-outline"
              onClick={() => accessRef.current?.resetForm()}
            >
              Reset
            </SwButton>

            <SwButton
              variant="primary"
              className="ml10"
              disabled={accessRef.current?.loading}
              onClick={() => accessRef.current?.submitRequest()}
            >
              Submit
            </SwButton>
          </div>
        }
      >
        <AccessLogServiceRequest ref={accessRef} onClose={handleClose} />
      </SwOffCanvas>

      <SwOffCanvas
        show={showAttendance}
        onClose={handleClose}
        title="Attendance"
        placement="end"
        backdrop="static"
        keyboard={false}
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton
              variant="dark-outline"
              onClick={() => attendanceRef.current?.resetForm()}
            >
              Reset
            </SwButton>

            {/* {!dayCareRef.current?.state?.btnStatus ? ( */}
            <SwButton
              variant="primary"
              className="ml10"
              disabled={attendanceRef.current?.loading}
              onClick={() => attendanceRef.current?.submitRequest()}
            >
              Submit
            </SwButton>

          </div>
        }
      >
        <AttendanceServiceRequest
          ref={attendanceRef} onClose={handleClose}
        />
      </SwOffCanvas>
      <SwOffCanvas
        show={showVisitor}
        onClose={handleClose}
        title="Visitor Management"
        placement="end"
        backdrop="static"
        keyboard={false}
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton
              variant="dark-outline"
              onClick={() => visitorRef.current?.resetForm()}
            >
              Reset
            </SwButton>
            <SwButton
              variant="primary"
              className="ml10"
              disabled={visitorRef.current?.loading}
              onClick={() => visitorRef.current?.submitRequest()}
            >
              Submit
            </SwButton>

          </div>
        }
      >
        <VisitorServiceRequest
          ref={visitorRef} onClose={handleClose}
        />
      </SwOffCanvas>

      <SwOffCanvas
        show={showSkyWatch}
        onClose={() => setShowSkyWatch(false)}
        title="SkyWatch"
        placement="end"
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton
              variant="dark-outline"
              onClick={() => skyWatchRef.current?.resetForm()}
            >
              Reset
            </SwButton>

            <SwButton
              variant="primary"
              className="ml10"
              disabled={skyWatchRef.current?.loading}
              onClick={() => skyWatchRef.current?.submitRequest()}
            >
              Submit
            </SwButton>
          </div>
        }
      >
        <SkyWatchServiceRequest
          ref={skyWatchRef}
          onClose={() => setShowSkyWatch(false)}
        />
      </SwOffCanvas>

      <SwOffCanvas
        show={showMeetingRoom}
        onClose={() => setShowMeetingRoom(false)}
        title="Meeting Room"
        placement="end"
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton
              variant="dark-outline"
              onClick={() => MeetingRoomRef.current?.resetForm()}
            >
              Reset
            </SwButton>

            <SwButton
              variant="primary"
              className="ml10"
              disabled={MeetingRoomRef.current?.loading}
              onClick={() => MeetingRoomRef.current?.submitRequest()}
            >
              Submit
            </SwButton>
          </div>
        }
      >
        <MeetingRoomServiceRequest
          ref={MeetingRoomRef}
          onClose={() => setShowMeetingRoom(false)}
        />
      </SwOffCanvas>

      <SwOffCanvas
        show={showDeskBooking}
        onClose={() => setShowDeskBooking(false)}
        title="Desk Booking"
        placement="end"
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton
              variant="dark-outline"
              onClick={() => DeskBookingRef.current?.resetForm()}
            >
              Reset
            </SwButton>

            <SwButton
              variant="primary"
              className="ml10"
              disabled={DeskBookingRef.current?.loading}
              onClick={() => DeskBookingRef.current?.submitRequest()}
            >
              Submit
            </SwButton>
          </div>
        }
      >
        <DeskBookingServiceRequest ref={DeskBookingRef} onClose={handleClose} />
      </SwOffCanvas>

    </>
  );
};

export default Sidebar;
